<template>
  <div>
    <a :href="categoryUrl" @click.prevent="selectCategory" class="category-item">
      <v-skeleton-loader
        :loading="loading"
        height="240"
        min-width="200"
        type="image, list-item"
        class="skeleton"
      >
        <img
          @error="handleImageError"
          :src="imageResize(categoryImage)"
          class="img"
          :class="[isActive ? 'active' : '']"
        />
        <h2>{{ title }}</h2>
      </v-skeleton-loader>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CategoryItem",
  props: {
    categoryImage: {
      type: String,
      default: "/images/testImg.png",
    },
    title: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    rootCategory: {
      type: String,
      default: null,
    },
    categoryData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
    }),
    isActive() {
      // Check if this subcategory is active in the URL params
      if (this.$route.params?.subCategory) {
        return this.$route.params.subCategory === this.slug;
      }
      return false;
    },
    categoryUrl() {
      let rootCategory = this.rootCategory || this.$route.params?.rootCategory;
      if (!rootCategory && this.categoryData?.RootCategory?.slug) {
        rootCategory = this.categoryData.RootCategory.slug;
      }
      if (!rootCategory) return '#';
      const currentSubCategory = this.$route.params?.subCategory;
      if (currentSubCategory === this.slug) {
        return `/${rootCategory}`;
      }
      return `/${rootCategory}/${this.slug}`;
    },
  },
  methods: {
    imageResize(image) {
      const reSizeImage = image.replace("images", "imageResize");
      return reSizeImage + "?width=500";
    },
    handleImageError(evt) {
      evt.target.src = "/images/imagePlaceHolder.jpg";
    },
    selectCategory() {
      // Try to get root category from: 1) category data, 2) prop, 3) route param
      let rootCategory = this.rootCategory || this.$route.params?.rootCategory;

      // If still no root category, try to get it from the category data
      if (!rootCategory && this.categoryData?.RootCategory?.slug) {
        rootCategory = this.categoryData.RootCategory.slug;
      }

      if (!rootCategory) {
        console.warn("CategoryItem: No root category available");
        return;
      }

      const currentSubCategory = this.$route.params?.subCategory;

      // Toggle subcategory selection
      let newPath;
      if (currentSubCategory === this.slug) {
        // If clicking the same subcategory, deselect it (go back to root category)
        newPath = `/${rootCategory}`;
      } else {
        // Select the new subcategory
        newPath = `/${rootCategory}/${this.slug}`;
      }

      // Keep query params but reset page
      const query = { ...this.$route.query };
      delete query.page;
      this.$router.push({
        path: newPath,
        query: query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.skeleton {
  justify-content: center;
}
.category-item {
  max-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
  text-decoration: none;
  color: inherit;
  &:hover {
    cursor: pointer;
  }
  .img {
    width: 150px;
    padding: 5px;
    height: 150px;
    object-fit: contain;
    border: 3.37px solid #f4f4f4;
    border-radius: 78.7px;
    transition: 0.2s;
    &.active,
    &:hover {
      border: 3.3px solid $primaryColor;
    }
  }
  h2 {
    font-size: 1.5rem;
    font-weight: 300;
    margin-top: 10px;
  }
}
.isMobile {
  h2 {
    font-size: 20px;
  }
  .skeleton {
    flex-direction: column;
  }
  .category-item {
    margin: 0px 10px;
  }
  .img {
    width: 125px;
    height: 125px;
    padding: 0px;
  }
}
</style>
